export const CONTACT_US_URL = 'mailto:moneysupport@zenbusiness.com';
